var _style, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTalentsandteams(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#003366;}\r\n\t.st1{fill:#FFC300;}\r\n\t.st2{fill:#00796B;}\r\n\t.st3{fill:#FF6F61;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25,0c-3.3,0-6.5,0.6-9.6,1.9c-3,1.3-5.8,3.1-8.1,5.4C5,9.6,3.2,12.4,1.9,15.4C0.6,18.5,0,21.7,0,25h8.4 c0-2.2,0.4-4.3,1.3-6.4c0.8-2,2.1-3.8,3.6-5.4c1.5-1.5,3.4-2.8,5.4-3.6c2-0.8,4.2-1.3,6.4-1.3V0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M50,25c0-3.3-0.6-6.5-1.9-9.6c-1.3-3-3.1-5.8-5.4-8.1c-2.3-2.3-5.1-4.2-8.1-5.4C31.5,0.6,28.3,0,25,0v8.4 c2.2,0,4.3,0.4,6.4,1.3c2,0.8,3.8,2.1,5.4,3.6c1.5,1.5,2.8,3.4,3.6,5.4c0.8,2,1.3,4.2,1.3,6.4H50z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M0,25c0,3.3,0.6,6.5,1.9,9.6c1.3,3,3.1,5.8,5.4,8.1c2.3,2.3,5.1,4.2,8.1,5.4c3,1.3,6.3,1.9,9.6,1.9v-8.4 c-2.2,0-4.3-0.4-6.4-1.3c-2-0.8-3.8-2.1-5.4-3.6c-1.5-1.5-2.8-3.4-3.6-5.4c-0.8-2-1.3-4.2-1.3-6.4H0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M25,50c3.3,0,6.5-0.6,9.6-1.9c3-1.3,5.8-3.1,8.1-5.4c2.3-2.3,4.2-5.1,5.4-8.1c1.3-3,1.9-6.3,1.9-9.6h-8.4 c0,2.2-0.4,4.3-1.3,6.4c-0.8,2-2.1,3.8-3.6,5.4c-1.5,1.5-3.4,2.8-5.4,3.6c-2,0.8-4.2,1.3-6.4,1.3V50z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTalentsandteams);
export default __webpack_public_path__ + "static/media/Talentsandteams.4c10172855b8b7f1285944d7366ea1de.svg";
export { ForwardRef as ReactComponent };